if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() { 
        super.hide();
      }
      show(opener) {
        super.show(opener);
        this.openedBy = opener;
        this.showActiveMedia();
        this.dispatchEvent(new CustomEvent('modal:opened', { bubbles: true }));
      }


showActiveMedia() {
  const activeMediaId = this.openedBy?.getAttribute('data-media-id');
  if (!activeMediaId) return;

  this.querySelectorAll('.modal-media-container[data-media-id]').forEach((element) => {
    const isActive = element.getAttribute('data-media-id') === activeMediaId;
    element.classList.toggle('active', isActive);
    element.style.display = isActive ? 'block' : 'none';
  });

  const activeMedia = this.querySelector(`[data-media-id="${activeMediaId}"]`);
  if (!activeMedia) return;

  const activeMediaTemplate = activeMedia.querySelector('template');
  const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

  activeMedia.classList.add('active');
  activeMedia.style.display = '';
  activeMedia.scrollIntoView({ behavior: 'smooth', block: 'center' });

  const container = this.querySelector('[role="document"]');
  if (container && activeMedia.offsetWidth) {
    container.scrollLeft = (activeMedia.offsetWidth - container.clientWidth) / 2;
  }

  if (
    activeMedia.nodeName === 'DEFERRED-MEDIA' &&
    activeMediaContent &&
    activeMediaContent.querySelector('.js-youtube')
  ) {
    activeMedia.loadContent();
  }

  const thumbnails = this.querySelectorAll('.modal-thumbnail');
  const activeThumbnail = this.querySelector(`.modal-thumbnail-item[data-media-id="${activeMediaId}"] .modal-thumbnail`);

  thumbnails.forEach(thumb => thumb.setAttribute('aria-current', 'false'));

  if (activeThumbnail) {
    activeThumbnail.setAttribute('aria-current', 'true');
    activeThumbnail.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}

    }  
  );
}

document.addEventListener('DOMContentLoaded', () => {
  class ProductMediaModal {
    constructor() {
      this.thumbnailList = document.querySelector('.modal-thumbnail-list--vertical');
      this.prevButton = document.querySelector('.vertical-button.slider-button--prev');
      this.nextButton = document.querySelector('.vertical-button.slider-button--next');
      this.thumbnails = document.querySelectorAll('.modal-thumbnail');
      this.mediaContainers = document.querySelectorAll('.modal-media-container');
      this.productModal = document.querySelector('product-modal');

      this.init();
    }

    init() {
      if (!this.thumbnailList || !this.prevButton || !this.nextButton) return;

      this.setupNavigation();
      this.setupThumbnailClicks();
      this.setupColorFilter();
    }

    setupNavigation() {
      const scrollAmount = 120;

      this.prevButton.addEventListener('click', () => {
        if (window.innerWidth > 990) {
          this.thumbnailList.scrollBy({ top: -scrollAmount, behavior: 'smooth' });
        } else {
          this.thumbnailList.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        }
      });

      this.nextButton.addEventListener('click', () => {
        if (window.innerWidth > 990) {
          this.thumbnailList.scrollBy({ top: scrollAmount, behavior: 'smooth' });
        } else {
          this.thumbnailList.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        }
      });
    }

    setupThumbnailClicks() {

      this.thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
      
        const thumbnailItem = thumbnail.closest('.modal-thumbnail-item');
      
      
        this.thumbnails.forEach(thumb => thumb.setAttribute('aria-current', 'false'));
        event.currentTarget.setAttribute('aria-current', 'true');
      
      
        if (this.productModal && thumbnailItem.hasAttribute('data-media-id')) {
          this.productModal.openedBy = thumbnailItem;
          this.productModal.show(thumbnailItem);
        }
      });
      });
    }
    setupColorFilter() {
      const activeModal = document.querySelector('.modal-media-container.active');
      const activeColor = activeModal?.getAttribute('data-alt');
      
      if (activeColor) {
        this.filterThumbnailsByColor(activeColor);
        
        // Show the first media container of this color if none is active
        if (!document.querySelector('.modal-media-container.active')) {
          const firstMediaOfColor = document.querySelector(`.modal-media-container[data-alt="${activeColor}"]`);
          if (firstMediaOfColor) {
            firstMediaOfColor.classList.add('active');
            firstMediaOfColor.style.display = 'block';
            
            // Also update the corresponding thumbnail
            const mediaId = firstMediaOfColor.getAttribute('data-media-id');
            const thumbnail = document.querySelector(`.modal-thumbnail-item[data-media-id="${mediaId}"] .modal-thumbnail`);
            if (thumbnail) {
              this.thumbnails.forEach(thumb => thumb.setAttribute('aria-current', 'false'));
              thumbnail.setAttribute('aria-current', 'true');
            }
          }
        }
      }
    }

    filterThumbnailsByColor(color) {
      // Filter thumbnails by color
      this.thumbnails.forEach(thumbnail => {
        const thumbnailItem = thumbnail.closest('.modal-thumbnail-item');
        const colorValue = thumbnailItem?.getAttribute('data-alt');
        
        if (colorValue === color) {
          thumbnailItem.style.display = '';
        } else {
          thumbnailItem.style.display = 'none';
        }
      });
    
      // Hide all media containers that don't match the active color
      this.mediaContainers.forEach(media => {
        const colorValue = media.getAttribute('data-alt');
        const mediaId = media.getAttribute('data-media-id');
        
        // We don't set display: block here, we only hide non-matching colors
        // The active media will be shown by click handlers or initial setup
        if (colorValue !== color) {
          media.classList.remove('active');
          media.style.display = 'none';
        }
      });
    }
  
  }

  const productModal = document.querySelector('product-modal');
  if (productModal) {
    if (productModal.getAttribute('open') !== null) {
      new ProductMediaModal();
    }

    productModal.addEventListener('modal:opened', () => {
      new ProductMediaModal();
    });
  }
});